import { TmrBaseResource } from 'stylewhere/api'

export class Places extends TmrBaseResource {
  static endpoint = '/profile/api/v1/places'
}
